import { z } from "zod";

/**
 * A per-line issue recorded on a draft sales order line when the order is
 * approved / submitted. `excludedFromOrder: true` means the line was left out
 * of the ERP order (the "exception items" the submission email lists);
 * `false` means it went through but needs attention.
 */
export const APPROVAL_ISSUE_TYPES = [
  "no_list_price",
  "unknown_inventory",
  "insufficient_inventory",
  "inactive_inventory",
  "customer_specific_discount_pending",
  "unmatched_product",
  /** Manually pulled from the order after the ERP rejected it. */
  "erp_rejected",
] as const;

export const ApprovalIssueTypeSchema = z.enum(APPROVAL_ISSUE_TYPES);
export type ApprovalIssueType = z.infer<typeof ApprovalIssueTypeSchema>;

export const ApprovalIssueSchema = z.object({
  type: ApprovalIssueTypeSchema,
  /** Whether this line item was excluded from the submitted order */
  excludedFromOrder: z.boolean(),
  /** Human-readable details, e.g. "Requested: 100, Available: 50" */
  details: z.string().optional(),
  /** ISO timestamp of when the issue was recorded */
  recordedAt: z.string(),
});
export type ApprovalIssue = z.infer<typeof ApprovalIssueSchema>;
